module.exports = __webpack_public_path__ + "1113e060b2c3cdd0c99d7c98486f319f.png";